import React from 'react';
import { useTheme } from '../../utils/theme';
export const PAY_FROM_ACCOUNTS = [{
  id: 'current',
  holder: 'Kashish',
  label: 'Current Account',
  number: '......0123 4567 8910',
  balance: 282992,
  iban: 'PK36BOPU0000001234567890'
}, {
  id: 'savings',
  holder: 'Kashish',
  label: 'Savings Account',
  number: '......0456 7890 1234',
  balance: 45500,
  iban: 'PK36BOPU0000000987654321'
}];
export const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    opacity: 0
  }),
  center: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut'
    }
  },
  exit: (direction: number) => ({
    x: direction < 0 ? '100%' : '-100%',
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: 'easeIn'
    }
  })
};
export function useRaastTheme() {
  const {
    isDark,
    isPlatinum
  } = useTheme();
  return {
    isDark,
    isPlatinum,
    bgStyle: isPlatinum ? 'bg-[#1C1C1E]' : isDark ? 'bg-[#1A0E08]' : 'bg-page-warm',
    cardBg: isPlatinum ? 'bg-[#2A2A2C]' : isDark ? 'bg-[#2D1810]' : 'bg-white',
    inputBg: isPlatinum ? 'bg-[#3A3A3C]' : isDark ? 'bg-[#3D2518]' : 'bg-[#F5EBE6]',
    textPri: isPlatinum || isDark ? 'text-white' : 'text-[#303030]',
    textSec: isPlatinum ? 'text-[#A0A0A5]' : isDark ? 'text-[#B8A89E]' : 'text-[#818285]',
    borderClr: isPlatinum ? 'border-[rgba(160,160,165,0.15)]' : isDark ? 'border-[rgba(243,112,36,0.1)]' : 'border-[#F0E8E3]'
  };
}